import { bool, number, object, string } from "prop-types";
import { observer } from "mobx-react";
import { getDateKey } from "@repo/structure";
import { CELL_WIDTHS } from "@utils";
import { getTimelineCellPeriods } from "@tools/EstimateEditor/utils/index";
import { Grid } from "@material-ui/core";
import { TimelineDistributionCell } from "./TimelineDistributionCell";
import { makeStyles } from "@material-ui/styles";

const getDividerStyle = (period, nextPeriod) => {
  if (!nextPeriod) return undefined;
  if ([period.type, nextPeriod.type].includes("month"))
    return "dividerSolid";
  if ([period.type, nextPeriod.type].includes("week"))
    return "dividerDashed";
  return "dividerDotted";
};

export const TimelineDistributionCells = observer(({
  element,
  allowEdition,
  expandedMonths,
  unmodifiedWidth,
  offsetLeft,
  offsetRight,
  backgroundColor,
  barWidth,
}) => {
  const classes = useStyle({ barWidth: barWidth - 4 });

  const periods = element.distributionByMonth.flatMap((month) => (
    getTimelineCellPeriods(month, expandedMonths)
  ));

  return (
    <Grid
      item container
      wrap="nowrap"
      alignItems="center"
      className={classes.cellsWrapper}
      style={{ width: unmodifiedWidth-4, marginLeft: -offsetLeft, backgroundColor }}
    >
      <Grid
        item container
        wrap="nowrap"
        alignItems="center"
        className={classes.cellsContainer}
      >
        {
          periods.map((period, index) => (
            <TimelineDistributionCell
              key={getDateKey(period.startDate)}
              element={element}
              period={period}
              dividerStyle={getDividerStyle(period, periods[index + 1])}
              allowEdition={allowEdition}
              shrinkWidth={index === 0 ? offsetLeft : (index === periods.length - 1 ? offsetRight : undefined)}
              previousPeriod={periods[index - 1]}
              nextPeriod={periods[index + 1]}
            />
          ))
        }
      </Grid>
    </Grid>
  );
});

TimelineDistributionCells.propTypes = {
  element: object.isRequired,
  allowEdition: bool,
  expandedMonths: object,
  unmodifiedWidth: number,
  offsetLeft: number,
  offsetRight: number,
  backgroundColor: string,
  barWidth: number,
};

const useStyle = makeStyles(() => ({
  cellsWrapper: {
    borderRadius: 10,
    height: "100%",
    transition: "width 250ms, margin-left 250ms",
    "&:not(:hover)": {
      width: ({ barWidth }) => `${barWidth}px !important`,
      marginLeft: "0 !important",
      overflow: "hidden",
    },
    // "&:hover > div": {
    //   marginLeft: "-2px !important"
    // },
    "&:hover .cell": {
      width: CELL_WIDTHS.VALUE.SMALL
    }
  },
  cellsContainer: {
    borderRadius: 10,
    height: "100%",
    transition: "margin-left 250ms",
    marginLeft: "-2px !important",
    width: "calc(100% + 4px)",
  },
}));
